
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/date_input/templates/range"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='start_date_wrapper'></div>\n<span class='date_separator'>\n  to\n</span>\n<div class='end_date_wrapper'></div>\n";
},"useData":true});
    }).call(this);
  